/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-interaction-background: var(--nve-sys-interaction-background-300);
  --nve-sys-interaction-field-background: var(--nve-sys-interaction-background-300);
  --nve-sys-layer-popover-arrow-padding: 0px;
  --nve-sys-layer-popover-arrow-offset: 0px;
  --nve-sys-layer-popover-offset: 0px;
  --border: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  --background: var(--nve-sys-layer-overlay-background);
  --color: var(--nve-sys-layer-overlay-color);
  --padding: 0;
  --box-shadow: var(--nve-ref-shadow-500);
  --gap: var(--nve-ref-space-sm);
  --top: 0px;
  --max-width: 400px;
  --width: 100vw;
  width: var(--width);
  max-width: var(--max-width);
  height: calc(100vh - var(--top));
  margin: initial !important;
  margin-block-start: var(--top) !important;
  position-area: unset !important; /* drawer uses its own fixed positioning with translation */
}

:host([size='sm']) {
  --max-width: 280px;
}

:host([size='lg']) {
  --max-width: 540px;
}

:host([position='left']) {
  transform: translateX(calc(-1 * var(--width))) !important;
}

:host([position='right']) {
  transform: translateX(var(--width)) !important;
}

:host(:popover-open) {
  transform: translateX(0) !important;
}

:host([inline]) {
  --nve-sys-interaction-background: var(--nve-sys-interaction-background-200);
  --nve-sys-interaction-field-background: var(--nve-sys-interaction-background-200);
  --background: var(--nve-sys-layer-container-background);
  --box-shadow: none;
  --border: 0;
  transition: none !important;
}

[internal-host] {
  border: var(--border);
  background: var(--background);
  color: var(--color);
  box-shadow: var(--box-shadow);
  bottom: 0 !important;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  height: 100%;
  width: 100%;
}

::backdrop {
  background: transparent;
}

:host([modal])::backdrop {
  /* --nve-sys-layer-backdrop-background (not available on top layer) */
  background: hsl(0 0% 0% / 0.07); /* eslint-disable-line @nvidia-elements/lint/no-unexpected-css-value */
}

.header {
  display: flex;
  gap: var(--gap);
}

.content {
  padding: var(--padding);
  display: flex;
  flex-direction: column;
  align-items: start;
  overflow: auto;
  flex: 1;
}

nve-icon-button {
  position: absolute;
  top: var(--nve-ref-size-200);
  right: var(--nve-ref-size-200);
  z-index: 99;
}

:host([position='bottom']),
:host([position='top']) {
  min-width: 100%;
  height: max-content;
}

:host([position='bottom']) [internal-host],
:host([position='top']) [internal-host] {
  height: min-content;
}

:host([position='left']) {
  inset: auto auto auto 0;
}

:host([position='right']) {
  inset: auto 0 auto auto;
}

:host([position='top']) {
  inset: 0 auto auto;
}

:host([position='bottom']) {
  inset: auto auto 0;
}
